export const COLOR_FROM_STRING_SATURATION = 75;
export const COLOR_FROM_STRING_LIGHTNESS = 45;
export const COLOR_FROM_STRING_HUE_RANGE = 360;
